import { useContext } from "react";
import { AppContext } from "../App";
import logo from "../assets/logo.png";
import { MdClose } from "react-icons/md";
import Backdrop from "./Backdrop";
import { IoMdCall } from "react-icons/io";

export default function SideBar(props) {
  const appContext = useContext(AppContext);

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({
      item,
    });

    if (appContext.isSideBarOpen) {
      closeSideBar();
    }
  }

  return (
    <>
      <Backdrop
        style={{
          visibility: appContext.isSideBarOpen === true ? "visible" : "hidden",
          opacity: appContext.isSideBarOpen === true ? "1" : "0",
          zIndex: "9999",
          pointerEvents: appContext.isSideBarOpen === true ? "auto" : "none",
        }}
      />
      <div
        className={`SideBar mShadow2 position-fixed top-0 start-0 h-100 w-85 w-md-75 w-lg-50 z-4 transition-all`}
        style={{
          transform: appContext.isSideBarOpen ? 'translateX(0)' : 'translateX(-100%)',
          zIndex: "var(--highestIndex)",
        }}
      >
        <div className="body mNoScrollBar">
          <div className="sidebar-header">
            <div
              className="logo-holder"
              onClick={() => {
                goTo("home");
              }}
            >
            <img src={logo} alt="Medal Global Engineering" />
            </div>

            <div className="close-btn" onClick={closeSideBar}>
              <MdClose size={32} />
            </div>
          </div>

          <div className="sidebar-brand px-4 py-3 border-bottom">
            <h4 className="mb-1 fw-bold text-dark">Medal Global Engineering</h4>
            <p className="text-muted mb-2 small">Engineering Excellence Across Tanzania</p>
            <a href="tel:+255782665569" className="btn btn-primary btn-sm rounded-pill px-4 d-flex gap-2 align-items-center justify-content-center">
              <IoMdCall size={18} /> <span className="fs-6">Call</span> 
            </a>
          </div>

          <nav className="flex-grow-1">
            <div className="nav-item px-4 py-3 border-bottom" onClick={() => goTo("home")} data-active={!appContext.navItem || appContext.navItem === "home"}>
              <span className="text fw-semibold">Home</span>
            </div>
            <div className="nav-item px-4 py-3 border-bottom" onClick={() => goTo("about_us")} data-active={appContext.navItem === "about_us"}>
              <span className="text fw-semibold">About Us</span>
            </div>
            <div className="nav-item px-4 py-3 border-bottom" onClick={() => goTo("services")} data-active={appContext.navItem === "services"}>
              <span className="text fw-semibold">Services</span>
            </div>
            <div className="nav-item px-4 py-3" onClick={() => goTo("contact_us")} data-active={appContext.navItem === "contact_us"}>
              <span className="text fw-semibold">Contact Us</span>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
}
